import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import {
  CreatePlanModal,
  EditPlanModal,
  PlanListFilters,
} from "@modules/plans/components";

import { usePlanList } from "./controller";
import { usePlanListColumns } from "./columns";

export const PlanList = React.memo(() => {
  const {
    rows,
    agreements,
    loading,
    selectedRows,
    dataToExport,
    createPlanModalRef,
    editPlanModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = usePlanList();

  const columns = usePlanListColumns(
    refetch,
    translate,
    editPlanModalRef,
    agreements
  );

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <PlanListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="plans.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createPlanModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreatePlanModal
        onComplete={() => {
          refetch();
          setSelectedRows([]);
        }}
        modalRef={createPlanModalRef}
      />
      <EditPlanModal
        onComplete={() => {
          refetch();
          setSelectedRows([]);
        }}
        modalRef={editPlanModalRef}
      />
    </List>
  );
});
